import { ValidationIssue } from 'api'

export const getOrderCounterpartyValidationIssues = (validationIssues: ValidationIssue[]) => {
  return validationIssues.filter(validationIssue => validationIssue.fieldName === 'counterparty')
}
